module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container is-child has-text-centered"
  }, [_c('article', {
    staticClass: "is-parent title"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Live Game")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.startGame()
      }
    }
  }, [_vm._v("Start Game")]), _vm._v(" "), _c('button', {
    staticClass: "button is-warning"
  }, [_vm._v("End Game")])]), _vm._v(" "), _c('article', {
    staticClass: "container is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Game Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Pause")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Reset")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Period - 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Situation - Even Handed 5v5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "container is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Game State - Even")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef30e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Fixtures/game-night-live.vue
// module id = 597
// module chunks = 30